import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import {
    COURSE_STAGE_VALUES,
    courseStageLabelId,
    type CourseStage,
} from '../model';
import CourseStageDot from './CourseStageDot';

/**
 * The current course stage named after its colour dot, then how many stages
 * are done, on one line. The name takes its size and weight from the text
 * around it; the count keeps its own.
 */
export default function CourseStageName({
    stage,
    done,
}: {
    stage: CourseStage;
    done: readonly CourseStage[];
}) {
    const intl = useIntl();
    return (
        <Box
            component="span"
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.75,
                minWidth: 0,
            }}
        >
            <CourseStageDot stage={stage} size={8} />
            <Typography
                component="span"
                variant="inherit"
                noWrap
                color="text.primary"
            >
                {intl.formatMessage({ id: courseStageLabelId(stage) })}
            </Typography>
            <Typography variant="monoMeta" fontWeight={400}>
                {intl.formatMessage(
                    { id: 'patientList.stage.doneCount' },
                    { done: done.length, total: COURSE_STAGE_VALUES.length }
                )}
            </Typography>
        </Box>
    );
}
